import React from 'react';
import { WarningRounded } from '@material-ui/icons';
import ModalConfirm from '../../../../../../components/ModalConfirm';

export const RemoveItemModal = ({
  title,
  subtitle,
  isLoading,
  onConfirm,
  confirmButtonMessage,
  onClose,
}) => (
  <ModalConfirm
    icon={WarningRounded}
    title={title}
    message={subtitle}
    onConfirm={onConfirm}
    onClose={onClose}
    isLoading={isLoading}
    confirmButtonMessage={confirmButtonMessage}
  />
);
